import { env } from '../../config/env';

export const BASE_URL = env.apiUrl;
// export const BASE_URL = env.apiUrlLocal;
